import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import PageHero from "../components/PageHero";
import { ministryGroups, siteMeta } from "../data/siteContent";

function MinistriesPage() {
  return (
    <>
      <PageHero
        eyebrow="Ministries"
        title="Growing Together. Serving One Another. Living on Mission."
        intro="Church life is more than attendance. We want every ministry expression to strengthen worship, discipleship, fellowship, prayer, and mission."
        metaTitle={`Ministries | ${siteMeta.churchName}`}
      />
      <section className="site-section">
        <Container>
          <Row className="g-4">
            {ministryGroups.map((item) => (
              <Col md={6} xl={3} key={item.title}>
                <article className="simple-card h-100">
                  <h2>{item.title}</h2>
                  <p>{item.text}</p>
                </article>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
}

export default MinistriesPage;
